
















import { Component, Vue } from "vue-property-decorator";
import { UtilitiesFunctions } from "@/helpers";
import { CellarsRequests } from "@/helpers";
import CellarDetail from "@/components/cellars/CellarDetail.vue";

@Component({
  components: {
    CellarDetail
  }
})
export default class CellarView extends Vue {
  handleRoute = UtilitiesFunctions.handleRoute;
  cellar?: any = null;
  headerImage = "";

  setHeaderImage(value: any) {
    if (value) {
      this.headerImage = value;
    } else {
      this.headerImage = require("@/assets/static/grey.jpg");
    }
  }
 
}
